<template lang="pug">
  div
    el-row(style="display: flex; flex-direction: column")
      div(ref="extratoSentenca").container
        el-form(:model="model" label-position="top" label-width="12em")
          vue-form-generator(
            :schema="schema",
            :model="model",
            :options="formOptions"
            ref="form",
            @model-updated="onModelUpdated"
          )
</template>

<script>

import { mapActions } from 'vuex'
import { component as VueFormGenerator } from 'vue-form-generator'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { schemas } from './schemas'

export default {
  components: {
    VueFormGenerator,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    despacho: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'NAO_ONEROSO'
    }
  },

  data () {
    return {
      limite: '',
      model: {
        interessado: {},
        imovel: {},
        numerosSei: '',
        limites: '',
        municipio: '',
        domicilio: ''
      },
      errorView: false,
      schema: {},
      nomeSchema: '',
      isOutorgadoPessoaFisica: null,
      municipiosListOutorgado: [],
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateBeforeSave: true,
        despacho: null,
        //  tipoModelo 5 corresponde à modelos de registro de imovel
        tipoModelo: 5
      },
      isRepresentantesLegais: false
    }
  },

  async mounted () {
    this.nomeSchema = this.tipo
    this.schema = schemas.emissao_extrato_sentenca[this.tipo]
    this.formOptions.despacho = {
      idProcesso: this.despacho.processo?.id,
      tipo: this.despacho.tipo,
      perfil: this.despacho.perfil
    }
    this.montarExtratoSentenca()
  },

  watch: {
    despacho: {
      handler (newDespacho) {
        if (newDespacho?.extratoSentenca?.extrato &&
            (!this.model.imovel || !this.model.imovel.comunidade)) {
          this.model = { ...newDespacho.extratoSentenca.extrato }
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      getInteressado: 'cadastro/getInteressado',
      getImovel: 'cadastro/getImovel'
    }),
    async montarExtratoSentenca () {
      let model = {...this.model}
      if (this.despacho?.extratoSentenca?.extrato) {
        model = {...this.despacho.extratoSentenca.extrato}
        if (model.imovel && !model.imovel.localizacao) {
          model.imovel.localizacao = model.imovel.comunidade || this.despacho.imovel?.comunidade || this.despacho.imovel?.localizacao || this.despacho.imovel?.localizacao || ''
        }
        if (model.imovel && !model.imovel.comunidade) {
          model.imovel.comunidade = this.despacho.imovel?.comunidade || this.despacho.imovel?.localizacao || model.imovel.localizacao || this.despacho.imovel?.comunidade || ''
        }
        if (model.imovel && !model.imovel.nome) {
          model.imovel.nome = this.despacho.imovel?.nome || this.despacho.imovel?.denominacao || model.imovel.denominacao || this.despacho.imovel?.nome || ''
        }
        if (model.imovel && !model.imovel.area) {
          model.imovel.area = this.despacho.imovel?.area || 0
        }
        if (!model.municipio) {
          model.municipio = this.despacho.municipios?.[0]?.nome || model.imovel?.municipio?.nome || this.despacho.imovel?.municipio?.nome || ''
        }
        if (!model.domicilio) {
          model.domicilio = model.imovel?.nome || this.despacho.imovel?.nome || ''
        }
      } else {
        const imovelData = await this.getImovel(this.despacho.processo.numeroProtocolo)
        const interessadoData = await this.getInteressado(this.despacho.processo.numeroProtocolo)
        model.imovel = imovelData && imovelData.length > 0 ? imovelData[0] : {}
        model.interessado = interessadoData && interessadoData.length > 0 ? interessadoData[0] : {}
        if (this.despacho.imovel) {
          model.imovel = {
            ...model.imovel,
            comunidade: this.despacho.imovel.comunidade || model.imovel.comunidade || this.despacho.imovel.localizacao || model.imovel.localizacao || this.despacho.imovel.comunidade || '',
            nome: this.despacho.imovel.nome || model.imovel.nome || this.despacho.imovel.denominacao || model.imovel.denominacao || this.despacho.imovel.nome || '',
            area: this.despacho.imovel.area || model.imovel.area || this.despacho.imovel.area || 0,
            municipio: this.despacho.imovel.municipio || model.imovel.municipio || null,
            localizacao: this.despacho.imovel.localizacao || model.imovel.localizacao || this.despacho.imovel.comunidade || model.imovel.comunidade || this.despacho.imovel.localizacao || '',
            bairro: this.despacho.imovel.bairro || model.imovel.bairro || '',
            logradouro: this.despacho.imovel.logradouro || model.imovel.logradouro || '',
            numero: this.despacho.imovel.numero || model.imovel.numero || '',
            latitude: this.despacho.imovel.latitude || model.imovel.latitude || '',
            longitude: this.despacho.imovel.longitude || model.imovel.longitude || ''
          }
        }

        if (typeof this.despacho.numeroSei === 'string') {
          model.numerosSei = [this.despacho.numeroSei]
        } else {
          model.numerosSei = this.despacho.numeroSei || []
        }
        if (typeof this.despacho.confrontantes === 'string') {
          model.limites = this.despacho.confrontantes.split(';').map(limite => limite.trim()).filter(limite => limite)
        } else {
          model.limites = this.despacho.confrontantes || []
        }
      }
      model.numeroProcesso = this.despacho.processo.numeroProcesso
      if (!model.domicilio) {
        model.domicilio = model.imovel?.nome || this.despacho.imovel?.nome || ''
      }
      if (!model.imovel) {
        model.imovel = {}
      }
      if (!Array.isArray(model.numerosSei)) {
        model.numerosSei = typeof model.numerosSei === 'string' ? [model.numerosSei] : []
      }
      if (!Array.isArray(model.limites)) {
        model.limites = typeof model.limites === 'string'
          ? model.limites.split(';').map(limite => limite.trim()).filter(limite => limite)
          : []
      }
      if (Array.isArray(this.despacho.municipios) && this.despacho.municipios.length > 0) {
        model.municipio = this.despacho.municipios[0].nome
      } else if (model.imovel?.municipio?.nome) {
        model.municipio = model.imovel.municipio.nome
      } else if (this.despacho.imovel?.municipio?.nome) {
        model.municipio = this.despacho.imovel.municipio.nome
      } else if (model.municipio) {
      } else {
        model.municipio = ''
      }
      if (!model.imovel.localizacao) {
        model.imovel.localizacao = this.despacho.imovel?.localizacao || model.imovel.comunidade || this.despacho.imovel?.comunidade || this.despacho.imovel?.localizacao || ''
      }
      if (!model.imovel.comunidade) {
        model.imovel.comunidade = this.despacho.imovel?.comunidade || this.despacho.imovel?.localizacao || model.imovel.localizacao || this.despacho.imovel?.comunidade || ''
      }
      if (!model.imovel.nome) {
        model.imovel.nome = this.despacho.imovel?.nome || this.despacho.imovel?.denominacao || model.imovel.denominacao || this.despacho.imovel?.nome || ''
      }
      if (!model.imovel.area) {
        model.imovel.area = this.despacho.imovel?.area || 0
      }
      if (!model.municipio) {
        model.municipio = this.despacho.municipios?.[0]?.nome || model.imovel?.municipio?.nome || this.despacho.imovel?.municipio?.nome || ''
      }
      if (!model.domicilio) {
        model.domicilio = model.imovel?.nome || this.despacho.imovel?.nome || ''
      }
      this.$set(this, 'model', model)
    },
    async save () {
      const isValid = await this.$refs.form.validate()
      const limitesValidos = Array.isArray(this.model.limites) && this.model.limites.length > 0
      if (isValid && limitesValidos) {
        this.errorView = false
        return this.salvarDespacho()
      } else {
        this.showNotificacao(
          this.errorView = true,
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Preencha todos os campos obrigatórios antes de continuar.'
        )
        return undefined
      }
    },
    salvarDespacho () {
      let despacho = this.despacho
      despacho.extratoSentenca = {extrato: {...this.model}}
      return despacho
    },
    async onModelUpdated (newValue, schema) {
      if (schema && schema.model) {
        const modelPath = schema.model.split('.')
        let current = this.model
        for (let i = 0; i < modelPath.length - 1; i++) {
          if (!current[modelPath[i]]) {
            current[modelPath[i]] = {}
          }
          current = current[modelPath[i]]
        }
        current[modelPath[modelPath.length - 1]] = newValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/components/AppEmissaoExtratoSentenca.vue